import { Box, Toolbar } from '@mui/material'
import { useEffect } from 'react'
import { Toolbar as RaToolbar, SaveButton } from 'react-admin'
import { useFormContext } from 'react-hook-form'

import { useFlushActionsCacheMutation } from 'apollo/personalization/mutations/FlushActionsCache.generated'

interface DefaultToolbarProps {
    isWithActionsFlush?: boolean
    onClick?: (hasError: boolean) => void
}

const DefaultToolbar = ({ isWithActionsFlush, onClick, ...props }: DefaultToolbarProps) => {
    const { formState } = useFormContext()

    const [flushActionsCache] = useFlushActionsCacheMutation()

    const handleSaveButtonClick = () => {
        // Check for specific field errors
        const hasErrors = !!(
            formState.errors.ajat_id ||
            formState.errors.final_price ||
            formState.errors.public_name
        )

        onClick && onClick(hasErrors)

        if (isWithActionsFlush) {
            flushActionsCache()
        } else {
            return false
        }
    }

    useEffect(() => {
        const toolbarHeight = 64
        document.body.style.paddingBottom = `${toolbarHeight}px`

        return () => {
            document.body.style.paddingBottom = '0px'
        }
    }, [])

    return (
        <>
            <Toolbar
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    margin: 0,
                    zIndex: 1300,
                    backgroundColor: 'background.paper',
                    width: '100%',
                    maxWidth: '100vw'
                }}
                disableGutters
            >
                <RaToolbar
                    {...props}
                    sx={{
                        margin: 0
                    }}
                >
                    <SaveButton onClick={handleSaveButtonClick} />
                </RaToolbar>
            </Toolbar>

            <Box sx={{ height: 64 }} />
        </>
    )
}
export default DefaultToolbar
